'use client';

import { createContext, useContext } from 'react';
import { getAuthHeaders } from '@/lib/authService'; // Import real auth service

// Simplified session context for the frontend diagnostic fix
const SessionContext = createContext<any>(undefined);

export function useSession() {
  const context = useContext(SessionContext);
  if (context === undefined) {
    // Instead of throwing an error immediately, return a fallback object
    console.warn('useSession called outside of SessionProvider, returning fallback values');
    return {
      backendSessionId: null,
      user: null,
      setUserSession: () => {},
      setBackendSessionId: () => {},
      clearSession: () => {},
      isReady: false,
      isLoading: true,
      getAuthHeaders: () => getAuthHeaders(), // Use real auth service for fallback too
      userRole: null,
    };
  }
  return context;
}

// Export the context for providers to use
export { SessionContext };
